import { createContext, useContext } from 'react'
import { Control } from '@trustero/trustero-api-web/lib/model/control_pb'

// Set around a requirement's list of linked controls, so each control's menu can
// offer to unlink it from that requirement.
export type RequirementMenuContextType = {
  requirementName: string
  onUnlink: (control: Control.AsObject) => void
}

export const RequirementMenuContext =
  createContext<RequirementMenuContextType | null>(null)

export const useRequirementMenu = (): RequirementMenuContextType | null =>
  useContext(RequirementMenuContext)
